<style lang="less" scoped>
	.editable {
		cursor: pointer;
	}
</style>

<template>
	<v-row v-bind:class="classes" :id="element.id">
		<EditorColumn v-for="childElement in element.elements" :key="childElement.id" :element="childElement" :focus="focus" v-on:delete="(a,b) => { $emit('delete',  a, b ) }"  v-on:focus="(childElement) => { $emit('focus', childElement) }"></EditorColumn>
	</v-row>
	
</template>




<script type="text/javascript">
	import EditorColumn from "../TextEditor/EditorColumn"
	export default {
		name: "EditorRow",
		props: {
			focus: {type: Object },
			element: {type: Object}
		},
		data: () =>{
			return {

			}
		}, 
		components:{
			EditorColumn: EditorColumn
		},
		computed:{
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			}
		},
		methods: {
			
		}
	}
</script>